import { domainHost } from '@/common/country-site';
const MTop = async (code: string, params: object) => {
  if (window.lib?.mtop?.config) {
    window.lib.mtop.config.prefix = 'acs';
    window.lib.mtop.config.subDomain = 'h'; // 线上
    window.lib.mtop.config.mainDomain = domainHost();
    const responseData = await window.lib.mtop.request({
      api: code, // 必须
      v: '1.0', // 必须
      H5Request: true,
      data: JSON.stringify(params), // 必须
    });
    const { data } = responseData;
    return data.target || data;
  }
};

export default MTop;
